import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "[uppercase-inp]",
})
export class UppercaseInpDirective {
    constructor(public ref: ElementRef) {}

    @HostListener("focusout", ["$event"]) onBlur($event) {
        $event.target.value = $event.target.value.toUpperCase();
        const evt = new Event("input");
        $event.target.dispatchEvent(evt);
    }
}
